import { render, staticRenderFns } from "./CreatePointSession.vue?vue&type=template&id=4b9c53e6"
import script from "./CreatePointSession.vue?vue&type=script&lang=js"
export * from "./CreatePointSession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports